import { AppScreenshot } from "../ui/AppScreenshot";
import { useLocale } from "../../i18n/LocaleProvider";

import styles from "./HeroMockup.module.css";

export function HeroMockup() {
  const { copy } = useLocale();

  return (
    <div className={styles.wrap} aria-hidden="true">
      <div className={styles.glow} />

      <div className={`${styles.window} ${styles.editor}`}>
        <div className={styles.titleBar}>
          <span className={styles.dot} />
          <span className={styles.dot} />
          <span className={styles.dot} />
          <span className={styles.winTitle}>{copy.mockupWindows.editor}</span>
        </div>
        <div className={styles.body}>
          <AppScreenshot variant="editor" decorative />
        </div>
      </div>

      <div className={`${styles.window} ${styles.control}`}>
        <div className={styles.titleBar}>
          <span className={styles.dot} />
          <span className={styles.dot} />
          <span className={styles.dot} />
          <span className={styles.winTitle}>{copy.mockupWindows.control}</span>
        </div>
        <div className={styles.body}>
          <AppScreenshot variant="control" decorative />
        </div>
      </div>

      <div className={`${styles.window} ${styles.presentation}`}>
        <div className={styles.titleBar}>
          <span className={styles.dot} />
          <span className={styles.dot} />
          <span className={styles.dot} />
          <span className={styles.winTitle}>
            {copy.mockupWindows.presentation}
          </span>
        </div>
        <div className={styles.body}>
          <AppScreenshot variant="presentation" decorative />
        </div>
      </div>
    </div>
  );
}
